// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageNotFound_PageNotFound__F1Ggx {
  background: black;
  font-style: italic;
  height: 100vh;
  top: 25vh;
}
.PageNotFound_PageNotFound__F1Ggx .PageNotFound_container__Xa3eF {
  position: absolute;
  transform: translate(-50%, -50%);
  top: 40%;
  left: 50%;
}
.PageNotFound_PageNotFound__F1Ggx .PageNotFound_glitch__mp3\\+T {
  color: rgb(223, 191, 191);
  position: relative;
  font-size: 9vw;
  margin: 70px 200px;
  animation: PageNotFound_glitch__mp3\\+T 5s 5s infinite;
}
.PageNotFound_PageNotFound__F1Ggx .PageNotFound_glitch__mp3\\+T::before {
  content: attr(data-text);
  position: absolute;
  left: -2px;
  text-shadow: -5px 0 magenta;
  background: black;
  overflow: hidden;
  top: 0;
  animation: PageNotFound_noise-1__158GP 3s linear infinite alternate-reverse, PageNotFound_glitch__mp3\\+T 5s 5.05s infinite;
}
.PageNotFound_PageNotFound__F1Ggx .PageNotFound_glitch__mp3\\+T::after {
  content: attr(data-text);
  position: absolute;
  left: 2px;
  text-shadow: -5px 0 lightgreen;
  background: black;
  overflow: hidden;
  top: 0;
  animation: PageNotFound_noise-2__PzLbN 3s linear infinite alternate-reverse, PageNotFound_glitch__mp3\\+T 5s 5s infinite;
}
@keyframes PageNotFound_glitch__mp3\\+T {
  1% {
    transform: rotateX(10deg) skewX(90deg);
  }
  2% {
    transform: rotateX(0deg) skewX(0deg);
  }
}
@keyframes PageNotFound_noise-1__158GP {
  3.3333333333% {
    clip-path: inset(65px 0 19px 0);
  }
  6.6666666667% {
    clip-path: inset(79px 0 16px 0);
  }
  10% {
    clip-path: inset(58px 0 20px 0);
  }
  13.3333333333% {
    clip-path: inset(98px 0 3px 0);
  }
  16.6666666667% {
    clip-path: inset(65px 0 35px 0);
  }
  20% {
    clip-path: inset(80px 0 13px 0);
  }
  23.3333333333% {
    clip-path: inset(94px 0 5px 0);
  }
  26.6666666667% {
    clip-path: inset(67px 0 2px 0);
  }
  30% {
    clip-path: inset(31px 0 48px 0);
  }
  33.3333333333% {
    clip-path: inset(55px 0 8px 0);
  }
  36.6666666667% {
    clip-path: inset(48px 0 12px 0);
  }
  40% {
    clip-path: inset(29px 0 31px 0);
  }
  43.3333333333% {
    clip-path: inset(87px 0 13px 0);
  }
  46.6666666667% {
    clip-path: inset(26px 0 31px 0);
  }
  50% {
    clip-path: inset(6px 0 71px 0);
  }
  53.3333333333% {
    clip-path: inset(79px 0 1px 0);
  }
  56.6666666667% {
    clip-path: inset(39px 0 56px 0);
  }
  60% {
    clip-path: inset(54px 0 8px 0);
  }
  63.3333333333% {
    clip-path: inset(5px 0 21px 0);
  }
  66.6666666667% {
    clip-path: inset(53px 0 10px 0);
  }
  70% {
    clip-path: inset(34px 0 61px 0);
  }
  73.3333333333% {
    clip-path: inset(39px 0 8px 0);
  }
  76.6666666667% {
    clip-path: inset(89px 0 4px 0);
  }
  80% {
    clip-path: inset(60px 0 14px 0);
  }
  83.3333333333% {
    clip-path: inset(65px 0 5px 0);
  }
  86.6666666667% {
    clip-path: inset(21px 0 78px 0);
  }
  90% {
    clip-path: inset(7px 0 41px 0);
  }
  93.3333333333% {
    clip-path: inset(3px 0 3px 0);
  }
  96.6666666667% {
    clip-path: inset(80px 0 11px 0);
  }
  100% {
    clip-path: inset(11px 0 76px 0);
  }
}
@keyframes PageNotFound_noise-2__PzLbN {
  0% {
    clip-path: inset(25px 0 55px 0);
  }
  3.3333333333% {
    clip-path: inset(74px 0 26px 0);
  }
  6.6666666667% {
    clip-path: inset(40px 0 1px 0);
  }
  10% {
    clip-path: inset(74px 0 20px 0);
  }
  13.3333333333% {
    clip-path: inset(1px 0 38px 0);
  }
  16.6666666667% {
    clip-path: inset(23px 0 4px 0);
  }
  20% {
    clip-path: inset(97px 0 2px 0);
  }
  23.3333333333% {
    clip-path: inset(10px 0 24px 0);
  }
  26.6666666667% {
    clip-path: inset(51px 0 2px 0);
  }
  30% {
    clip-path: inset(27px 0 33px 0);
  }
  33.3333333333% {
    clip-path: inset(41px 0 41px 0);
  }
  36.6666666667% {
    clip-path: inset(33px 0 4px 0);
  }
  40% {
    clip-path: inset(52px 0 13px 0);
  }
  43.3333333333% {
    clip-path: inset(54px 0 18px 0);
  }
  46.6666666667% {
    clip-path: inset(7px 0 42px 0);
  }
  50% {
    clip-path: inset(13px 0 65px 0);
  }
  53.3333333333% {
    clip-path: inset(87px 0 5px 0);
  }
  56.6666666667% {
    clip-path: inset(17px 0 36px 0);
  }
  60% {
    clip-path: inset(27px 0 64px 0);
  }
  63.3333333333% {
    clip-path: inset(66px 0 11px 0);
  }
  66.6666666667% {
    clip-path: inset(95px 0 3px 0);
  }
  70% {
    clip-path: inset(71px 0 21px 0);
  }
  73.3333333333% {
    clip-path: inset(54px 0 9px 0);
  }
  76.6666666667% {
    clip-path: inset(98px 0 1px 0);
  }
  80% {
    clip-path: inset(98px 0 1px 0);
  }
  83.3333333333% {
    clip-path: inset(17px 0 21px 0);
  }
  86.6666666667% {
    clip-path: inset(1px 0 100px 0);
  }
  90% {
    clip-path: inset(15px 0 26px 0);
  }
  93.3333333333% {
    clip-path: inset(97px 0 3px 0);
  }
  96.6666666667% {
    clip-path: inset(1px 0 93px 0);
  }
  100% {
    clip-path: inset(39px 0 36px 0);
  }
}
.PageNotFound_PageNotFound__F1Ggx .PageNotFound_scanlines__7ruwn {
  overflow: hidden;
  mix-blend-mode: difference;
}
.PageNotFound_PageNotFound__F1Ggx .PageNotFound_scanlines__7ruwn::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: repeating-linear-gradient(to bottom, transparent 0%, rgba(255, 255, 255, 0.05) 0.5%, transparent 1%);
  animation: PageNotFound_fudge__5NfPk 7s ease-in-out alternate infinite;
}
@keyframes PageNotFound_fudge__5NfPk {
  from {
    transform: translate(0px, 0px);
  }
  to {
    transform: translate(0px, -2%);
  }
}
.PageNotFound_PageNotFound__F1Ggx .PageNotFound_glow__CS7gF {
  text-shadow: 0 0 1000px rgb(223, 191, 191);
  color: transparent;
}
.PageNotFound_PageNotFound__F1Ggx .PageNotFound_subtitle__hohDE {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 100;
  font-size: 0.8vw;
  color: rgba(165, 141, 141, 0.4);
  text-transform: uppercase;
  letter-spacing: 1em;
  text-align: center;
  left: 17%;
  animation: PageNotFound_glitch-2__C6YWO 5s 5.02s infinite;
}
@keyframes PageNotFound_glitch-2__C6YWO {
  1% {
    transform: rotateX(10deg) skewX(70deg);
  }
  2% {
    transform: rotateX(0deg) skewX(0deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/views/PageNotFound/PageNotFound.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AACF;AACE;EACE,kBAAA;EACA,gCAAA;EACA,QAAA;EACA,SAAA;AACJ;AAEE;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,qDAAA;AAAJ;AAGE;EACE,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,0HAAA;AADJ;AAKE;EACE,wBAAA;EACA,kBAAA;EACA,SAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,uHAAA;AAHJ;AAOE;EACE;IACE,sCAAA;EALJ;EAOE;IACE,oCAAA;EALJ;AACF;AAQE;EAGI;IAGE,+BAAA;EAVN;EAOI;IAGE,+BAAA;EAPN;EAII;IAGE,+BAAA;EAJN;EACI;IAGE,8BAAA;EADN;EAFI;IAGE,+BAAA;EAEN;EALI;IAGE,+BAAA;EAKN;EARI;IAGE,8BAAA;EAQN;EAXI;IAGE,8BAAA;EAWN;EAdI;IAGE,+BAAA;EAcN;EAjBI;IAGE,8BAAA;EAiBN;EApBI;IAGE,+BAAA;EAoBN;EAvBI;IAGE,+BAAA;EAuBN;EA1BI;IAGE,+BAAA;EA0BN;EA7BI;IAGE,+BAAA;EA6BN;EAhCI;IAGE,8BAAA;EAgCN;EAnCI;IAGE,8BAAA;EAmCN;EAtCI;IAGE,+BAAA;EAsCN;EAzCI;IAGE,8BAAA;EAyCN;EA5CI;IAGE,8BAAA;EA4CN;EA/CI;IAGE,+BAAA;EA+CN;EAlDI;IAGE,+BAAA;EAkDN;EArDI;IAGE,8BAAA;EAqDN;EAxDI;IAGE,8BAAA;EAwDN;EA3DI;IAGE,+BAAA;EA2DN;EA9DI;IAGE,8BAAA;EA8DN;EAjEI;IAGE,+BAAA;EAiEN;EApEI;IAGE,8BAAA;EAoEN;EAvEI;IAGE,6BAAA;EAuEN;EA1EI;IAGE,+BAAA;EA0EN;EA7EI;IAGE,+BAAA;EA6EN;AACF;AAzEE;EAGI;IAGE,+BAAA;EAuEN;EA1EI;IAGE,+BAAA;EA0EN;EA7EI;IAGE,8BAAA;EA6EN;EAhFI;IAGE,+BAAA;EAgFN;EAnFI;IAGE,8BAAA;EAmFN;EAtFI;IAGE,8BAAA;EAsFN;EAzFI;IAGE,8BAAA;EAyFN;EA5FI;IAGE,+BAAA;EA4FN;EA/FI;IAGE,8BAAA;EA+FN;EAlGI;IAGE,+BAAA;EAkGN;EArGI;IAGE,+BAAA;EAqGN;EAxGI;IAGE,8BAAA;EAwGN;EA3GI;IAGE,+BAAA;EA2GN;EA9GI;IAGE,+BAAA;EA8GN;EAjHI;IAGE,8BAAA;EAiHN;EApHI;IAGE,+BAAA;EAoHN;EAvHI;IAGE,8BAAA;EAuHN;EA1HI;IAGE,+BAAA;EA0HN;EA7HI;IAGE,+BAAA;EA6HN;EAhII;IAGE,+BAAA;EAgIN;EAnII;IAGE,8BAAA;EAmIN;EAtII;IAGE,+BAAA;EAsIN;EAzII;IAGE,8BAAA;EAyIN;EA5II;IAGE,8BAAA;EA4IN;EA/II;IAGE,8BAAA;EA+IN;EAlJI;IAGE,+BAAA;EAkJN;EArJI;IAGE,+BAAA;EAqJN;EAxJI;IAGE,+BAAA;EAwJN;EA3JI;IAGE,8BAAA;EA2JN;EA9JI;IAGE,8BAAA;EA8JN;EAjKI;IAGE,+BAAA;EAiKN;AACF;AA7JE;EACE,gBAAA;EACA,0BAAA;AA+JJ;AA5JE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EAEA,gHAAA;EAOA,sEAAA;AAuJJ;AApJE;EACE;IACE,8BAAA;EAsJJ;EApJE;IACE,8BAAA;EAsJJ;AACF;AAnJE;EACE,0CAAA;EACA,kBAAA;AAqJJ;AAlJE;EACE,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,yDAAA;AAoJJ;AAjJE;EACE;IACE,sCAAA;EAmJJ;EAjJE;IACE,oCAAA;EAmJJ;AACF","sourcesContent":[".PageNotFound {\n  background: black;\n  font-style: italic;\n  height: 100vh;\n  top: 25vh;\n\n  .container {\n    position: absolute;\n    transform: translate(-50%, -50%);\n    top: 40%;\n    left: 50%;\n  }\n\n  .glitch {\n    color: rgb(223, 191, 191);\n    position: relative;\n    font-size: 9vw;\n    margin: 70px 200px;\n    animation: glitch 5s 5s infinite;\n  }\n\n  .glitch::before {\n    content: attr(data-text);\n    position: absolute;\n    left: -2px;\n    text-shadow: -5px 0 magenta;\n    background: black;\n    overflow: hidden;\n    top: 0;\n    animation: noise-1 3s linear infinite alternate-reverse,\n      glitch 5s 5.05s infinite;\n  }\n\n  .glitch::after {\n    content: attr(data-text);\n    position: absolute;\n    left: 2px;\n    text-shadow: -5px 0 lightgreen;\n    background: black;\n    overflow: hidden;\n    top: 0;\n    animation: noise-2 3s linear infinite alternate-reverse,\n      glitch 5s 5s infinite;\n  }\n\n  @keyframes glitch {\n    1% {\n      transform: rotateX(10deg) skewX(90deg);\n    }\n    2% {\n      transform: rotateX(0deg) skewX(0deg);\n    }\n  }\n\n  @keyframes noise-1 {\n    $steps: 30;\n    @for $i from 1 through $steps {\n      #{percentage($i*calc(1/$steps))} {\n        $top: random(100);\n        $bottom: random(101 - $top);\n        clip-path: inset(#{$top}px 0 #{$bottom}px 0);\n      }\n    }\n  }\n\n  @keyframes noise-2 {\n    $steps: 30;\n    @for $i from 0 through $steps {\n      #{percentage($i*calc(1/$steps))} {\n        $top: random(100);\n        $bottom: random(101 - $top);\n        clip-path: inset(#{$top}px 0 #{$bottom}px 0);\n      }\n    }\n  }\n\n  .scanlines {\n    overflow: hidden;\n    mix-blend-mode: difference;\n  }\n\n  .scanlines::before {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n\n    background: repeating-linear-gradient(\n      to bottom,\n      transparent 0%,\n      rgba(255, 255, 255, 0.05) 0.5%,\n      transparent 1%\n    );\n\n    animation: fudge 7s ease-in-out alternate infinite;\n  }\n\n  @keyframes fudge {\n    from {\n      transform: translate(0px, 0px);\n    }\n    to {\n      transform: translate(0px, -2%);\n    }\n  }\n\n  .glow {\n    text-shadow: 0 0 1000px rgb(223, 191, 191);\n    color: transparent;\n  }\n\n  .subtitle {\n    font-family: Arial, Helvetica, sans-serif;\n    font-weight: 100;\n    font-size: 0.8vw;\n    color: rgba(165, 141, 141, 0.4);\n    text-transform: uppercase;\n    letter-spacing: 1em;\n    text-align: center;\n    left: 17%;\n    animation: glitch-2 5s 5.02s infinite;\n  }\n\n  @keyframes glitch-2 {\n    1% {\n      transform: rotateX(10deg) skewX(70deg);\n    }\n    2% {\n      transform: rotateX(0deg) skewX(0deg);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PageNotFound": `PageNotFound_PageNotFound__F1Ggx`,
	"container": `PageNotFound_container__Xa3eF`,
	"glitch": `PageNotFound_glitch__mp3+T`,
	"noise-1": `PageNotFound_noise-1__158GP`,
	"noise-2": `PageNotFound_noise-2__PzLbN`,
	"scanlines": `PageNotFound_scanlines__7ruwn`,
	"fudge": `PageNotFound_fudge__5NfPk`,
	"glow": `PageNotFound_glow__CS7gF`,
	"subtitle": `PageNotFound_subtitle__hohDE`,
	"glitch-2": `PageNotFound_glitch-2__C6YWO`
};
export default ___CSS_LOADER_EXPORT___;
